import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import UploadViewPres from './UploadViewPres';

export default class UploadViewContainer extends Component {
  static propTypes = {
    attachments: PropTypes.array,
    menu: PropTypes.array,
  };

  state = {
    showMenu: {},
  };

  showMenuHandler = i => {
    if (this.props.menu) {
      this.setState(prevState => ({ showMenu: { [`menu${i}`]: !prevState.showMenu[`menu${i}`] } }));
    }
  };

  menuHandler = (j, i) => {
    this.props.menu[j].handler(i);
    this.showMenuHandler(i);
  };

  render() {
    const {
      attachments,
      menu,
      selectable,
      onSelected,
      showBorder,
      selectAction,
      deleteSelected,
      deleteEnabled,
      selectedAttachments,
    } = this.props;

    return (
      <Fragment>
        {attachments && (
          <UploadViewPres
            selectAction={selectAction}
            attachments={attachments}
            showMenu={this.state.showMenu}
            showMenuHandler={this.showMenuHandler}
            menuHandler={this.menuHandler}
            menu={menu}
            selectable={selectable}
            onSelected={onSelected}
            showBorder={showBorder}
            deleteSelected={deleteSelected}
            deleteEnabled={deleteEnabled}
            selectedAttachments={selectedAttachments}
          />
        )}
      </Fragment>
    );
  }
}
